import React from 'react';
import { Share2 } from 'lucide-react';
import { formatDate } from '../../lib/formats';
import { libelle, nomPays, referenceLisible, texteSur } from '../../lib/libelles';
// Bouton HTML simple, sans dépendance au kit d'interface.

export const WhatsAppShareButton = ({ trip, truck, driver }) => {
  const handleShare = () => {
    // Only proceed if we have a trip
    if (!trip) return;

    // Use a fallback for dates incase it corresponds to offline queue format
    const date = formatDate(trip.departure_date, 'Date non définie');
    const nomChauffeur = texteSur(
      driver?.full_name || `${driver?.first_name || ''} ${driver?.last_name || ''}`.trim(),
      'Non assigné',
    );

    // Construct the professional message
    // French is standard for Mali/Senegal logistics
    const text = `🚛 *E-CARBU - SUIVI DE VOYAGE* 🚛
    
*📅 Date Départ:* ${date}
*🔢 Réf Voyage:* ${referenceLisible(trip.reference, 'Non précisée')}
*📍 Trajet:* ${nomPays(trip.departure_country, 'Origine')} ➡️ ${nomPays(trip.destination_country, 'Destination')}

*🚚 Camion (plaque):* ${texteSur(truck?.matricule, 'Non assigné')}
*👤 Chauffeur:* ${nomChauffeur}

*⛽ Cargaison (Prévue):* ${trip.fuel_quantity_estimated || 0} Litres
*📊 Statut Actuel:* *${libelle('tripStatus', trip.status, 'En cours')}*

_Généré via E-Carbu_`;

    // Encode for URL and open WhatsApp Web/App
    const encodedText = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/?text=${encodedText}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleShare}
      className="bg-success hover:bg-success text-white flex items-center justify-center gap-2 px-4 py-2 rounded-md shadow-sm transition-colors w-full sm:w-auto"
      title="Partager le résumé du voyage sur WhatsApp"
    >
      <Share2 className="size-4" />
      <span>Partager sur WhatsApp</span>
    </button>
  );
};

export default WhatsAppShareButton;
